import { currentLanguage } from '../currentLanguage';
import { getFormatter } from '../hooks/useLang';

/**
 * This is in its own file because Playwright acts funny if it imports an scss module.
 */
export function getListViewItemAriaLabel(employeeName: string, from: Date) {
  return `${
    currentLanguage.SelectTheShift
  } ${employeeName} ${getFormatter().dayMonthYear(from)} ${getFormatter().time(from, false)}`;
}
